'use client'

import { cn } from '@/lib/utils'
import { useSearchParams } from 'next/navigation'
import { ReactNode, useEffect } from 'react'

interface MarqueeProps {
  children: ReactNode
  className?: string
  speed?: 'slow' | 'normal' | 'fast'
  direction?: 'left' | 'right'
  pauseOnHover?: boolean
  repeat?: number
  mask?: boolean
}

export const Marquee = ({
  children,
  className,
  speed = 'normal',
  direction = 'left',
  pauseOnHover = false,
  repeat = 2,
  mask = true,
}: MarqueeProps) => {
  const speedClass = {
    slow: 'animate-marquee-slow',
    normal: 'animate-marquee',
    fast: 'animate-marquee-fast',
  }[speed]

  const searchParams = useSearchParams()
  const scrollToMarquee = searchParams?.get('scroll_to_marquee')

  //nếu url có tham số scroll_to_marquee=true thì scroll đến marquee
  useEffect(() => {
    if (scrollToMarquee === 'true') {
      const marqueeElement = document.getElementById('marquee')
      if (marqueeElement) {
        marqueeElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [scrollToMarquee])

  return (
    <div
      id='marquee'
      className={cn(
        'relative flex overflow-hidden',
        pauseOnHover && 'group',
        className
      )}
      style={{
        maskImage: mask
          ? 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)'
          : 'none',
        WebkitMaskImage: mask
          ? 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)'
          : 'none',
      }}
    >
      {Array.from({ length: repeat }).map((_, i) => (
        <div
          key={i}
          className={cn(
            'flex shrink-0 items-center',
            speedClass,
            direction === 'right' && '[animation-direction:reverse]',
            pauseOnHover && 'group-hover:[animation-play-state:paused]'
          )}
        >
          {children}
        </div>
      ))}
    </div>
  )
}

interface MarqueeItemProps {
  children: ReactNode
  className?: string
}

export const MarqueeItem = ({ children, className }: MarqueeItemProps) => {
  return (
    <div
      className={cn('flex shrink-0 items-center whitespace-nowrap', className)}
    >
      {children}
    </div>
  )
}
